import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationReportUIHelpers";

const OrganizationReportUIContext = createContext();

export function useOrganizationReportUIContext() {
  return useContext(OrganizationReportUIContext);
}

export const OrganizationReportUIConsumer =
  OrganizationReportUIContext.Consumer;

export function OrganizationReportUIProvider({
  organizationReportUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganizationReport = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganizationReport,
    openDetailOrganizationReportPage:
      organizationReportUIEvents.openDetailOrganizationReportPage
  };

  return (
    <OrganizationReportUIContext.Provider value={value}>
      {children}
    </OrganizationReportUIContext.Provider>
  );
}
